import React, { useState } from "react"
import AntTable from "../../components/table/Table"
import { Flex } from "antd"
import { ColumnsType } from "antd/es/table"
import { MemberService } from "../../services/MemberService"

interface Props {
    user: {
        id: number
    }
}

const MemberReferral = (props: Props) => {

    const [refreshData, setRefreshData] = useState<boolean>(false)

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'User ID',
            align: 'center',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'Fullname',
            align: 'center',
            dataIndex: 'full_name',
            key: 'full_name',
            render: (value, record) => {
                return value
            }
        },
        {
            title: 'Referral Code',
            align: 'center',
            dataIndex: 'my_reference_code',
            key: 'my_reference_code',
            render: (value, record) => {
                return value
            }
        }
    ])

    React.useEffect(() => {
        setRefreshData(p => !p)
    }, [props.user?.id])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
            user_id: props.user?.id,
        }
        const res = await MemberService.getReferrals(payload)
        return res
    }

    return (
        <AntTable
            refresh={refreshData}
            defaultColumns={false}
            menuOptions={false}
            search={false}
            title="Referral History"
            columns={columns}
            onLoadData={onLoadData}
        />
    )

}

export default MemberReferral